import styled, { css } from 'styled-components';
import is from 'styled-is';

import { groupageBackground, skinsGroupage } from 'modules/journey/card/styled';

const rowStyles = css`
  border: 2px solid var(--grey100);
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 ${(props) => props.theme.base.gridSizes.XS} 0
    ${(props) => props.theme.base.gridSizes.S};
  position: relative;
  background: #fff;

  ${is('lightCell')`
    opacity: .6;
  `}

  ${Object.keys(skinsGroupage).map(
    (skin) => css`
    &.${skin}:before${`{
      background: ${skinsGroupage[skin]}
    }`}
  `
  )}

  &[draggable] {
    cursor: move;
  }

  &:before {
    content: '';
    display: block;
    width: ${(props) => props.theme.base.gridSizes.XS};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    ${groupageBackground};
  }
`;

const StopRowStyled = styled.div`
  ${rowStyles}
`;

export { rowStyles };
export default StopRowStyled;
